import React from 'react';
import { connect } from 'react-redux';
import { AudioTimelineComponent } from './audioTool/menus/AudioTimelineComponent';
import { ResizeAccordionButton } from '../components/menus/ResizeAccordionButton';
import { ContextMenu } from '../components/menus/ContextMenu';
import { AudioToolBrowser } from '../components/menus/AudioToolBrowser';
import { AudioToolHeader } from '../components/audioTool/menus/AudioToolHeader';
import { DeleteAlert } from '../components/menus/DeleteAlert';
import { ExportAlert } from '../components/menus/ExportAlert';
import { RecorderPopup } from '../components/menus/RecorderPopup';
import { ProductTitleAlert } from '../components/menus/ProductTitleAlert';
import { DescriptionMenu } from '../components/menus/DescriptionMenu';
import { ExitAlert } from '../components/menus/ExitAlert';
import { LostSessionAlert } from '../components/menus/LostSessionAlert';
import { NoInternetConnectionAlert } from '../components/menus/NoInternetConnectionAlert';
import { AppLoader } from './appLoader/AppLoader';
import storeManager from '../store/StoreManager';
import { setWindowSize } from '../actions/ProductionActions';
import { showDescription } from '../actions/MenuActions';
import styles from './App.scss';
import { Loader } from './appLoader/Loader';
import { SaveButtonAudioEditor } from '../components/menus/SaveButtonAudioEditor';
import { NavigationBar } from '../components/menus/NavigationBar';
import { InternetExplorerAlert } from '../components/menus/InternetExplorerAlert';
import { NoAccessAlert } from '../components/menus/NoAccessAlert';
import { SearchMenu } from '../components/menus/SearchMenu';
import properties from '../constants/Properties';
import appParameters from '../components/utils/AppParameters';
import platformDetection from '../components/utils/PlatformDetection';
import mouseUtils from '../components/utils/MouseUtils';
import populateMediaFilesUtils from '../components/utils/PopulateMediaFilesUtils';
import exporterUtils from '../components/utils/ExporterUtils';
import apiService from '../services/ApiService';
import configuration from '../constants/Configuration';
import { checkKeyboardCommand } from './utils/KeyboardShortcuts';
import audioToolUtils from './audioTool/utils/AudioToolUtils';
import saveManager from './utils/SaveManager';
import audioVolumeUtils from './utils/AudioVolumeUtils';
import { AudioAlert } from '../components/menus/AudioAlert';
import apiServiceUtils from './utils/ApiServiceUtils';

const AudioEditorAppWrapper = React.createClass({
    propTypes: {
        children: React.PropTypes.object,
        appReady: React.PropTypes.bool
    },
    getInitialState() {
        return {
            originalWidth: -1,
            originalHeight: -1
        };
    },
    onScroll(e) {
        e.preventDefault();
        e.stopPropagation();
        window.scrollTo(0, 0);
    },
    onKeyDown(e) {
        if (e.keyCode == 13) // Enter ... used to close the Keyboard on the iPads
            window.scrollTo(0, 0);
    },
    onUnload() {
        if (configuration.LOAD_LOCAL)
            return;

        if (appParameters.submitId > 0) {
            apiService.unlockProduction(appParameters.submitId);
        }
    },
    componentDidMount() {
        const { dispatch } = this.props;

        saveManager.initAutoSave();
        audioVolumeUtils.addEventListener();

        window.addEventListener('beforeunload', this.onUnload);

        if (platformDetection.isIOS() == true) {
            window.addEventListener('orientationchange', this.onResizeApp);

            window.addEventListener('blur', this.onScroll);
            window.addEventListener('focusout', this.onScroll);
            document.addEventListener('keydown', this.onKeyDown);
        } else {
            window.addEventListener('resize', this.onResize);
            document.addEventListener('keydown', this.onKeyDownHandler);
        }

        dispatch(setWindowSize(window.innerWidth, window.innerHeight));

        this.setState({
            originalWidth: window.innerWidth,
            originalHeight: window.innerHeight
        });
    },
    componentWillUnmount() {
        audioVolumeUtils.removeEventListener();

        window.removeEventListener('beforeunload', this.onUnload);

        if (platformDetection.isIOS() == true) {
            window.removeEventListener('orientationchange', this.onResizeApp);

            window.removeEventListener('blur', this.onScroll);
            window.removeEventListener('focusout', this.onScroll);
            document.removeEventListener('keydown', this.onKeyDown);
        } else {
            window.removeEventListener('resize', this.onResize);
            document.removeEventListener('keydown', this.onKeyDownHandler);
        }

        populateMediaFilesUtils.cleanTimers();
        exporterUtils.removeEvent();
    },
    onKeyDownHandler(e) {
        checkKeyboardCommand(e, this.props.dispatch);

        if (platformDetection.isIOS())
            return;

        var isTabPressed = (e.key === 'Tab' || e.keyCode === 9);

        if (!isTabPressed) {
            return;
        }

        var modal;
        var firstFocusableEl;
        var lastFocusableEl;

        modal = document.getElementById('exportPopup');

        if (modal) {
            firstFocusableEl = document.getElementById('exportFirstFocusableCheckBox');

            if (!firstFocusableEl)
                firstFocusableEl = document.getElementById('exportFirstFocusableButton');

            lastFocusableEl = document.getElementById('exportLastFocusableButton');
        }

        modal = document.getElementById('productionInitialTitleAlert');

        if (modal) {
            firstFocusableEl = document.getElementById('productionInitialTitle');
            lastFocusableEl = document.getElementById('productionInitialTitleButton');
        }

        modal = document.getElementById('lostSessionAlert');

        if (modal) {
            firstFocusableEl = document.getElementById('lostSessionAlertButton');
            lastFocusableEl = document.getElementById('lostSessionAlertButton');
        }

        modal = document.getElementById('deleteAlert');

        if (modal) {
            firstFocusableEl = document.getElementById('deleteAlertFirstFocusableElement');
            lastFocusableEl = document.getElementById('deleteAlertLastFocusableElement');
        }

        modal = document.getElementById('audioAlert');

        if (modal) {
            firstFocusableEl = document.getElementById('audioAlertFirstFocusableElement');
            lastFocusableEl = document.getElementById('audioAlertLastFocusableElement');
        }

        modal = document.getElementById('recordingPopup');

        if (modal) {
            firstFocusableEl = document.getElementById('recordingFirstFocusableElement');
            lastFocusableEl = document.getElementById('recordingLastFocusableElement');
        }

        if (!firstFocusableEl || !lastFocusableEl)
            return;

        if (e.shiftKey) /* shift + tab */ {
            if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } else /* tab */ {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    },
    onResizeApp() {
        saveManager.saveData();
        setTimeout(this.onResize, 100);
    },
    onResize() {
        this.refreshView();
    },
    refreshView () {
        const { dispatch } = this.props;

        if (platformDetection.isIOS() == true) {
            if (window.innerWidth > window.innerHeight)
                dispatch(setWindowSize(this.state.originalWidth, this.state.originalHeight));
            else
                dispatch(setWindowSize(window.innerWidth, window.innerHeight));

            setTimeout(this.updateView, 20);
        } else {
            dispatch(setWindowSize(window.innerWidth, window.innerHeight));

            setTimeout(this.updateView, 20);
        }
    },
    updateView() {
        this.forceUpdate();
    },
    onAppClick(e) {
        if (!platformDetection.isIOSApp())
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        const store = storeManager.getStore();
        const state = storeManager.getState();
        const showDescriptionValue = state.menu.showDescription;

        if (showDescriptionValue && e.target.className != 'describeItem' && e.target.className != 'fa fa-eye')
            store.dispatch(showDescription(false));

    },
    render () {
        if (platformDetection.isIE() == true) {
            if (this.props.captionsLoaded == true)
                return <InternetExplorerAlert windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
            else
                return <AppLoader />;
        }

        if (this.props.hasNotAccess == true) {
            if (this.props.captionsLoaded == true)
                return <NoAccessAlert windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
            else
                return <AppLoader />;
        }

        if (!this.props.appReady) {
            return <AppLoader />;
        }

        const appStyle = {
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            background: '#F2F2F2'
        };

        var elements = [];
        var extraHeight = 0;
        var noInternetAlertHeight = apiServiceUtils.getNoInternetConnectionAlertHeight();
        var searchHeight = properties.CLIPART_BUTTON_HEIGHT;

        if (platformDetection.isIOS()) {
            extraHeight = properties.CLIPART_BUTTON_HEIGHT_OLD;
            searchHeight = properties.CLIPART_BUTTON_HEIGHT_OLD;

            if (platformDetection.isIOSApp())
                elements.push(<NavigationBar key={'appElement10'} windowWidth={this.props.windowWidth}/>);
        }

        extraHeight = extraHeight + noInternetAlertHeight;

        elements.push(<AudioToolHeader width={this.props.windowWidth - this.props.accordionWidth} timelines={this.props.timelines} dispatch={this.props.dispatch} windowHeight={this.props.windowHeight - extraHeight} key={'appElement1'}/>);
        elements.push(<SaveButtonAudioEditor dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement5'}/>);
        elements.push(<SearchMenu dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement31'}/>);
        elements.push(<AudioToolBrowser height={this.props.windowHeight - noInternetAlertHeight - searchHeight} top={noInternetAlertHeight + searchHeight} accordionWidth={this.props.accordionWidth} dispatch={this.props.dispatch} windowHeight={this.props.windowHeight - noInternetAlertHeight - searchHeight} key={'appElement2'}/>);
        elements.push(<AudioTimelineComponent buttonsHolderWidth={this.props.buttonsHolderWidth} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - extraHeight} key={'appElement3'}/>);
        elements.push(<ResizeAccordionButton buttonsHolderWidth={this.props.buttonsHolderWidth} isLeft={true} dispatch={this.props.dispatch} timelines={this.props.timelines} accordionWidth={this.props.accordionWidth} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - extraHeight} key={'appElement15'}/>);
        elements.push(<ResizeAccordionButton buttonsHolderWidth={this.props.buttonsHolderWidth} dispatch={this.props.dispatch} timelines={this.props.timelines} accordionWidth={this.props.accordionWidth} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - extraHeight} key={'appElement0'}/>);
        elements.push(<ContextMenu dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement4'}/>);
        elements.push(<DeleteAlert dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement6'}/>);
        elements.push(<AudioAlert dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement14'}/>);
        elements.push(<ExportAlert dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement7'}/>);
        elements.push(<ProductTitleAlert windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement13'}/>);
        elements.push(<RecorderPopup windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement17'}/>);
        elements.push(<LostSessionAlert windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement8'}/>);
        elements.push(<NoInternetConnectionAlert windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight} key={'appElement16'}/>);
        elements.push(<Loader windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - extraHeight} key={'appElement9'}/>);

        if (platformDetection.isIOSApp()) {
            elements.push(<DescriptionMenu key={'appElement11'} windowWidth={this.props.windowWidth}/>);
            elements.push(<ExitAlert key={'appElement12'} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight - noInternetAlertHeight}/>);
        }

        return (
            <div id='app' style={appStyle} className={styles.app} onTouchEnd={this.onAppClick} onClick={this.onAppClick}>
                {elements}
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const store = storeManager.getStore();
    let windowWidth = state.production.windowWidth;
    let windowHeight = state.production.windowHeight;
    var accordionWidth = state.accordion.width;
    var hasNotAccess = state.menu.hasNotAccess;
    const timelines = state.audioEditor.timelines;
    const soundClipartModel = state.music.soundClipartModel;
    var buttonsHolderWidth = state.menu.buttonsHolderWidth;
    var showLostSessionAlert = state.menu.showLostSessionAlert;

    if (!(windowWidth > 0))
        windowWidth = window.innerWidth;

    if (!(windowHeight > 0))
        windowHeight = window.innerHeight;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    if (!hasNotAccess)
        hasNotAccess = false;

    if (buttonsHolderWidth == undefined)
        buttonsHolderWidth = audioToolUtils.buttonsHolderWidth();

    return {
        appReady: state.session.appReady && state.session.captionsLoaded && soundClipartModel != undefined,
        dispatch: store.dispatch,
        captionsLoaded: state.session.captionsLoaded,
        accordionWidth,
        windowWidth,
        windowHeight,
        hasNotAccess,
        timelines,
        buttonsHolderWidth,
        showLostSessionAlert
    };
}

export const AudioEditorApp = connect(mapStateToProps)(AudioEditorAppWrapper);



/** WEBPACK FOOTER **
 ** ./src/components/AudioEditorApp.js
 **/